var _polygon, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon2, _path10, _path11, _path12, _path13, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _polygon3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _polygon4, _polygon5, _polygon6, _path25, _path26, _path27, _polygon7, _polygon8, _polygon9, _path28, _path29, _path30, _rect11, _polygon10, _polygon11, _polygon12, _path31, _path32, _polygon13, _polygon14, _polygon15, _path33, _path34, _path35, _ellipse, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e4498934-9316-40f7-be62-b2794b6cdbd7",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "180.37 118.6 182.47 128.51 232.3 139.31 180.37 118.6",
    fill: "#bcbec0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M211.45,558.07V572a1.1,1.1,0,0,0,1.1,1.1h7.22a1.1,1.1,0,0,0,1.1-1.1h0a1.1,1.1,0,0,1,1.1-1.1H224s.66,1.6,4.06,2.2h13.33a2,2,0,0,0,1.24-3.58c-1.92-1.54-5.8-3-13.57-3.23a10.67,10.67,0,0,1-8.8-9Z",
    fill: "#f27500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.12,545.12l-6.53,9.38a2.21,2.21,0,0,0,.55,3.07l4.11,2.86a2.21,2.21,0,0,0,3.07-.55h0l2.58,1.8s-.37,1.69,2.08,4.13l10.94,7.62a2,2,0,0,0,3.07-2.24c-.7-2.36-3-5.81-9.29-10.4,0,0-6.54-5.35-3.1-12.77Z",
    fill: "#f27500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.84,213.43a4,4,0,0,0,3.39,2.94c5.29.65,7.85,3,7.85,3,12.12,7.15,2.18,24.82,2.18,24.82-5.47,10.3,6.94,22.08,6.94,22.08,13,14.73-2.07,19.82-2.07,19.82L168,304.14c-22.47-10.28-20.65-26.47-20.65-26.47s-.21-16.88,18.93-32.65c0,0,8.63-6.73,9.47-17.67,0,0,3.93-37.17,35.39-21.93a12.61,12.61,0,0,1,6.67,7.83C217.81,213.31,217.83,213.37,217.84,213.43Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M239.83,291l-.17-.32c4.52-2.47,7.27-5.54,8.19-9.14,1.21-4.76-1-9.64-3.14-12.91a32.58,32.58,0,0,0-7.78-7.85,29.06,29.06,0,0,1-7.72-9.94l.34-.12a28.66,28.66,0,0,0,7.6,9.77,32.81,32.81,0,0,1,7.86,7.95c3.07,4.76,4.18,9.32,3.19,13.19C247.26,285.28,244.44,288.43,239.83,291Z",
    fill: "#000000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M147.18,277.75c-.07-.14-7.6-14.24,5.59-26.92a30.62,30.62,0,0,1,5-3.7c2.46-1.56,7.26-5.49,11.72-14.25a44.8,44.8,0,0,0,3.9-11.7c1.24-6.3,6-21.2,23.31-23.45.21,0,19.49-.83,20.41,13.24l-.36,0c-.89-13.71-19.83-12.91-20-12.9-16.46,2.14-21.47,15.43-23,23.16A44.75,44.75,0,0,1,169.77,233c-4.5,8.84-9.35,12.81-11.84,14.39a31.19,31.19,0,0,0-4.91,3.66c-13,12.49-5.59,26.35-5.52,26.49Z",
    fill: "#000000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165.47,311.62c-.21-.12-20.51-12.25-17.31-29l.36.08c-3.15,16.5,16.92,28.49,17.12,28.6Z",
    fill: "#000000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M173.38,545s3.41,6.41,8,7.22c0,0,6.49-26.19,13.26-39.14,0,0,22-38.61,28.41-44.62,0,0,23.91-22.84,11.46-56.1,0,0-11.38-28.57-10.51-48.15l-8,16.89L204.55,422,178,416.93l17.26,49.36s-13.16,16-17.3,53.7C177.92,520,175,541.23,173.38,545Z",
    fill: "#000000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.38,545s3.41,6.41,8,7.22c0,0,6.49-26.19,13.26-39.14,0,0,22-38.61,28.41-44.62,0,0,23.91-22.84,11.46-56.1,0,0-11.38-28.57-10.51-48.15l-8,16.89L204.55,422,178,416.93l17.26,49.36s-13.16,16-17.3,53.7C177.92,520,175,541.23,173.38,545Z",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.36,320.7c3.06-18.16-13.68-48.82-13.68-48.82-27.92,5.79-21.22,21.58-21.22,21.58L170.27,357s-13,20.56-10.45,39.89c1.86,14.06,15,24,28.86,19.73a42.24,42.24,0,0,0,6.59-2.55s22.61-9.33,15.32-51.17Z",
    fill: "#f27500"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "761.26 344.26 758.46 362.7 678.31 377.52 761.26 344.26",
    fill: "#bcbec0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M561.86,293.72s35.68,15.81,32.39,33.32c0,0,5.35,8-32.39,30.4Z",
    fill: "#000000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M561.86,293.72s35.68,15.81,32.39,33.32c0,0,5.35,8-32.39,30.4Z",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M268.79,337.06s-21.18-20.49,3.26-32.92l-.4,35.57Z",
    fill: "#000000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M268.79,337.06s-21.18-20.49,3.26-32.92l-.4,35.57Z",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 270.05,
    y: 221.19,
    width: 228.82,
    height: 258.08,
    fill: "#bcbec0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 270.05,
    y: 221.19,
    width: 228.82,
    height: 258.08,
    fill: "none",
    opacity: 0.39
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 289.68,
    y: 255.65,
    width: 272.17,
    height: 258.08,
    fill: "#ccc"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 330.42,
    y: 292.22,
    width: 51.22,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 309.85,
    y: 322.78,
    width: 137.22,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 309.85,
    y: 348.32,
    width: 84.62,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 411.81,
    y: 348.32,
    width: 53.8,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 471.97,
    y: 348.32,
    width: 17.28,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 454.12,
    y: 322.78,
    width: 51.96,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 392.84,
    y: 292.22,
    width: 32.93,
    height: 11.93,
    rx: 5.96,
    fill: "#bcbec0"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "474.74 255.65 474.74 305.79 495.18 292.22 516.01 305.79 516.01 255.65 474.74 255.65",
    opacity: 0.2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M167,363.06s16.16,2.94,23.66-4.37l-.15-2.92s-11.53,2.72-19.7,0Z",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M196.68,271.88s7.46,10.32,13.86,8.4c0,0,3.15,0,2.77-8.4,0,0,17.72,17.81,15.86,47.79l-18.72.4s1.68-7.52-4-25.64C206.45,294.43,199.83,277.33,196.68,271.88Z",
    fill: "#ccc"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M211.27,368.52s9.51,1.36,14.69-6.7a15.28,15.28,0,0,0,2.11-9.73l-.36-3.77h-2.32l-3.06,11.39h-6.27v3.94h-5.34Z",
    fill: "#ccc"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M234.53,412.39S223.05,383.52,224,364.24c0,0,6.11-5.24,3.65-16,0,0,7.63.68,6.72-8.54,0,0-.88-7.86-5.24-6l3.94-14.06H229c.08-3.56.19-17.66-5.33-30.49a89.83,89.83,0,0,0-10.63-17.56c-.56-.71-1-1.3-1.38-1.7a54.38,54.38,0,0,1,19.47,11c10,9.06,20.37,25.26,22.17,53.77l7.2,0,0,15.55s-22.27,7.26-21.07-9.07c0,0-3.64,4.46-.68,16.41A50.26,50.26,0,0,0,245,372c3.89,6.26,11,20.12,6.36,31.8C251.33,403.77,246.38,414,234.53,412.39Z",
    fill: "#f27500"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M239.68,341.17l-.36,0c2.18-35.08-11.17-52.51-11.3-52.68l.28-.22C228.44,288.42,241.87,305.94,239.68,341.17Z",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M178,416.93s-1,10.28,6.64,21.51c0,0,7.22,13.62,5.61,37.46,0,0-3.53,21.17,4.45,37.21A108.72,108.72,0,0,1,202.32,532l7.73,27.47,11.42-2.41a143,143,0,0,1-3.41-37.67L215.46,441s.17-59.42,8.56-76.8c0,0-4.11,4.5-12.75,4.28,0,0,5.5,33.59-16.79,45.94C194.48,414.46,184.25,419.28,178,416.93Z",
    fill: "#000000"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M196.68,256.38s.33,5.77,0,15.5c0,0,6.59,10.55,14.29,8.64,0,0,2.69,0,2.34-8.58,0,0-2.32-2.31-3.29-12.62Z",
    fill: "#f9b499"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M249.55,381s-5.8,9.78-13.53,4.61a11.66,11.66,0,0,1-3.47-3.79c-.13-.21-.26-.44-.39-.68A27.74,27.74,0,0,1,230,360.65c.8-3.06,1.54-8.26-.13-12.64a7.12,7.12,0,0,1-1.1.19,8.13,8.13,0,0,1-1.08,0,20.24,20.24,0,0,1,.53,5.84c-.14,3.28-1.08,7.28-4.27,10.17,0,0-1.69,17.16,10.51,48.15,0,0,12.06,2.08,17.12-9.56C251.56,402.83,255.72,395.9,249.55,381Z",
    opacity: 0.2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M761.06,391.65c-2.42-1.24-3.88-1.89-3.89-1.89l.29-.67s1.49.66,3.93,1.92Z",
    fill: "#000000"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M727.81,544.22c-2.93-.07-5.93-.22-8.93-.46l.06-.72c3,.23,6,.39,8.88.45Zm8.93-.07,0-.72c3-.12,6-.33,8.87-.64l.08.72C742.75,543.82,739.75,544,736.74,544.15ZM710,542.82c-2.88-.38-5.85-.84-8.82-1.37l.13-.71c3,.53,5.91,1,8.79,1.36Zm44.52-.57-.13-.71c2.94-.53,5.86-1.17,8.68-1.91l.18.7C760.41,541.08,757.47,541.72,754.51,542.25Zm17.28-4.54-.24-.68c2.8-1,5.58-2.1,8.24-3.32l.3.66C777.41,535.59,774.62,536.72,771.79,537.71Zm16.26-7.42-.36-.63c2.5-1.43,4.94-3,7.26-4.61l.23-.17.42.59-.24.17C793,527.29,790.57,528.85,788.05,530.29Zm14.49-10.48-.5-.53a66.18,66.18,0,0,0,6.07-6.46l.56.46A67.56,67.56,0,0,1,802.54,519.81ZM813.89,506l-.61-.39a67.33,67.33,0,0,0,4.16-7.82l.66.29A66.72,66.72,0,0,1,813.89,506Zm7.3-16.32-.7-.21a62.76,62.76,0,0,0,1.88-8.66l.72.11A63.05,63.05,0,0,1,821.19,489.69Zm2.55-17.7H823v-.21a63.36,63.36,0,0,0-.59-8.62l.72-.1a65,65,0,0,1,.59,8.72Zm-3.13-17.5a68.81,68.81,0,0,0-3-8.35l.67-.28a69.53,69.53,0,0,1,3,8.43Zm-7-16.27a84.94,84.94,0,0,0-4.84-7.44l.59-.42a84.7,84.7,0,0,1,4.87,7.5Zm-10.37-14.38c-1.89-2.17-3.95-4.35-6.1-6.46l.5-.52c2.18,2.13,4.24,4.32,6.15,6.5Zm-12.67-12.46c-2.22-1.89-4.56-3.76-7-5.56l.44-.58c2.41,1.81,4.76,3.69,7,5.59Zm-14.23-10.7c-2.45-1.63-5-3.23-7.54-4.73l.37-.63c2.56,1.52,5.11,3.12,7.58,4.76Z",
    fill: "#000000"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M692.37,539.68c-1.4-.32-2.82-.65-4.25-1l.18-.7,4.23,1Z",
    fill: "#000000"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "761.26 344.26 744.84 328.74 678.31 377.52 761.26 344.26",
    fill: "#ccc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "774.09 353.13 799.34 375.52 678.31 377.52 774.09 353.13",
    fill: "#ccc"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "678.31 377.52 763.66 376.11 759.1 390.26 678.31 377.52",
    fill: "#bcbec0"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M96.11,383.21s-1-1.23-2.72-3.41l.58-.44c1.69,2.17,2.69,3.38,2.7,3.39Z",
    fill: "#000000"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.11,372.83c-1.71-2.32-3.43-4.71-5.11-7.1l.59-.42c1.68,2.39,3.4,4.78,5.11,7.09ZM78,358.51c-1.62-2.44-3.23-4.9-4.78-7.34l.62-.39c1.54,2.43,3.14,4.9,4.77,7.32Zm-9.37-14.79c-1.52-2.53-3-5.08-4.4-7.57l.63-.35c1.4,2.48,2.88,5,4.39,7.55ZM60.1,328.46c-1.37-2.64-2.69-5.28-3.91-7.84l.66-.31c1.21,2.55,2.53,5.18,3.9,7.81Zm-7.51-15.82c-1.18-2.75-2.27-5.49-3.25-8.14l.68-.25c1,2.64,2.07,5.36,3.23,8.11ZM46.54,296.2c-.88-2.88-1.64-5.73-2.26-8.47l.7-.16c.62,2.72,1.38,5.56,2.25,8.42Zm-3.83-17.09a75,75,0,0,1-.69-8.75h.73a75.61,75.61,0,0,0,.67,8.66Zm.49-17.43-.72-.09a48.45,48.45,0,0,1,1.9-8.59l.69.23A46.89,46.89,0,0,0,43.2,261.68ZM67,252h0a14.87,14.87,0,0,1-5.43-1.14l.26-.68a14.15,14.15,0,0,0,5.17,1.1h0a9.15,9.15,0,0,0,3.11-.52l.24.69A10,10,0,0,1,67,252Zm-12.9-5.84a25.5,25.5,0,0,1-3.47-3.94c-1.19,1.64-1.88,2.82-1.89,2.83l-.18.31-.63-.37.18-.3s.77-1.32,2.08-3.11a26.77,26.77,0,0,1-1.44-2.43l.64-.34c.39.75.81,1.46,1.26,2.15.72-1,1.57-2,2.53-3.06l.54.49c-1,1.11-1.9,2.22-2.64,3.21a24,24,0,0,0,3.51,4Zm22.36-1-.69-.23a9.75,9.75,0,0,0,.48-3.06,10.71,10.71,0,0,0-1.32-5.11l.64-.34a11.34,11.34,0,0,1,1.4,5.45A10.63,10.63,0,0,1,76.47,245.15ZM60.36,232.9l-.35-.64a12.58,12.58,0,0,1,6-1.68h0a9.85,9.85,0,0,1,2.65.36l-.19.7A8.91,8.91,0,0,0,66,231.3h0A11.88,11.88,0,0,0,60.36,232.9Zm-14.3-2.18a27.05,27.05,0,0,1,.15-8.81l.72.13a26.4,26.4,0,0,0-.15,8.58Zm3.69-16.82-.66-.31c1.21-2.63,2.54-5.26,3.95-7.82l.64.35C52.28,208.67,51,211.28,49.75,213.9Zm8.39-15.26-.61-.4c1.58-2.43,3.26-4.86,5-7.19l.58.43C61.38,193.81,59.71,196.21,58.14,198.64Zm10.42-14-.55-.47c1.89-2.2,3.88-4.37,5.92-6.45l.52.51C72.42,180.33,70.44,182.49,68.56,184.68Zm12.2-12.42-.49-.54c2.17-1.93,4.43-3.82,6.72-5.62l.45.57C85.16,168.46,82.91,170.34,80.76,172.26Zm13.71-10.74-.41-.6c2.38-1.63,4.85-3.22,7.36-4.73l.38.62C99.3,158.31,96.83,159.9,94.47,161.52Zm14.92-9-.34-.64c2.55-1.34,5.2-2.63,7.86-3.85l.3.66C114.56,149.92,111.93,151.21,109.39,152.54Zm15.84-7.24-.26-.67c2.67-1.06,5.44-2.07,8.21-3l.24.69C130.65,143.25,127.9,144.25,125.23,145.3Zm16.5-5.59-.2-.7c2.76-.79,5.61-1.54,8.46-2.23l.17.7C147.32,138.17,144.48,138.92,141.73,139.71Z",
    fill: "#000000"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M158.69,135.61l-.14-.71c1.41-.28,2.84-.55,4.28-.8l.13.71Z",
    fill: "#000000"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "173.15 123.11 157.82 137.53 232.36 139.34 173.15 123.11",
    fill: "#ccc"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.38 108.38 180.37 118.6 232.36 139.34 189.38 108.38",
    fill: "#ccc"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "182.17 146.85 180.37 138.08 232.05 139.34 182.17 146.85",
    fill: "#bcbec0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M260.82,541.79l-.29-220.41s.9,9.91,11.12,18.33L412,438.29,450,435l133.85-92.77s12.42-7.61,10.42-20.83v220.4a6.81,6.81,0,0,1-6.82,6.81H267.64A6.82,6.82,0,0,1,260.82,541.79Z",
    fill: "#000000"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M272.05,548.59,423.49,426a14.61,14.61,0,0,1,9.16-3.24h0a14.53,14.53,0,0,1,9.37,3.42L587.43,548.59Z",
    fill: "#000000"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M272.05,548.59,423.49,426a14.61,14.61,0,0,1,9.16-3.24h0a14.53,14.53,0,0,1,9.37,3.42L587.43,548.59Z",
    opacity: 0.2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 515.09,
    y: 447.64,
    width: 173.12,
    height: 122.38,
    rx: 7.77,
    fill: "#000000"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "521.36 570.01 593.13 511.45 617.39 511.86 679.55 570.01 521.36 570.01",
    fill: "#000000"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "521.36 570.01 593.13 511.45 617.39 511.86 679.55 570.01 521.36 570.01",
    fill: "#fff",
    opacity: 0.39
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "518.82 300.58 498.87 286.56 477.94 300.58 477.94 245.68 518.82 245.68 518.82 300.58",
    fill: "#d1d3d4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M594.47,512.34l-76.91-51.13a5.5,5.5,0,0,1-2.47-4.59v-3.46a5.52,5.52,0,0,1,5.52-5.52H682.69a5.52,5.52,0,0,1,5.52,5.52v3.92a5.53,5.53,0,0,1-2.25,4.45l-68.57,50.33a20.58,20.58,0,0,1-11.82,3.74h0A20.5,20.5,0,0,1,594.47,512.34Z",
    fill: "#000000"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M594.47,512.34l-76.91-51.13a5.5,5.5,0,0,1-2.47-4.59v-3.46a5.52,5.52,0,0,1,5.52-5.52H682.69a5.52,5.52,0,0,1,5.52,5.52v3.92a5.53,5.53,0,0,1-2.25,4.45l-68.57,50.33a20.58,20.58,0,0,1-11.82,3.74h0A20.5,20.5,0,0,1,594.47,512.34Z",
    opacity: 0.2
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "196.68 359.71 199.73 320.42 233.09 319.67 222.33 359.71 196.68 359.71",
    fill: "#fff"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.65 363.65 216.06 363.65 216.06 359.71 218.45 320 194.15 320.38 190.65 363.65",
    fill: "#ccc"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "190.65 363.65 216.06 363.65 216.06 359.71 218.45 320 194.15 320.38 190.65 363.65",
    fill: "#fff",
    opacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M161.49,344s-1.89,17.45,29,11.79c0,0,24.76-1.46,31.83-7.45v-8.61h-33s13-41,5.18-53.5c0,0-6.83-11.56-13.44-7.79,0,0-5.18.91-9.5,15.58-.77,2.62-1.63,5.21-2.65,7.75C166,308.92,160.24,325.92,161.49,344Z",
    fill: "#f27500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M222.33,339.71l2.84-8.72a1.15,1.15,0,0,1,1.1-.8h0a1.16,1.16,0,0,1,1.15,1.38l-.64,3.38s4.7-3.41,6.31,0c0,0,5.62,12.72-5.38,13.37h-5.38Z",
    fill: "#f9b499"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M196.82,261.74l-.08-4.49h14.15l-.49,5.27A17,17,0,0,1,196.82,261.74Z",
    fill: "#f4a68e"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.44,
    cy: 237.75,
    rx: 24.03,
    ry: 17.06,
    transform: "translate(-46.08 426.09) rotate(-86)",
    fill: "#f9b499"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M210.89,214.66s-4.5,17-22.54,23.12l-5.6-4.78,4.51-19.28,8.15-5Z",
    fill: "#000000"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M207.31,217.6s2.65,9.49,16.95,11.66l-1.93-8.7-9-7.46-6.81-1.56Z",
    fill: "#000000"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M208.23,214a23.25,23.25,0,0,1-.11,8.6,18.27,18.27,0,0,1-3.79,7.75,15.92,15.92,0,0,1-3.22,2.91,13.89,13.89,0,0,1-3.9,1.92,13.22,13.22,0,0,0-2,.73,7.24,7.24,0,0,0-1.72,1.24,9.12,9.12,0,0,0-2.2,3.64,9.1,9.1,0,0,1,2.08-3.77,6.93,6.93,0,0,1,1.73-1.31,13.36,13.36,0,0,1,2-.8,17.73,17.73,0,0,0,2-.81,16.08,16.08,0,0,0,1.82-1.11,15.29,15.29,0,0,0,3.13-2.88,18.25,18.25,0,0,0,3.8-7.57,18.88,18.88,0,0,0,.55-4.24A29.46,29.46,0,0,0,208.23,214Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.e16ae92d66f64b0434ac3ac934b19074.svg";
export { ForwardRef as ReactComponent };